import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BreadcrumbComponent } from '@shared/components/breadcrumb/breadcrumb.component';
import { Subscription } from 'rxjs';
import { FaqService } from './faq.service';
import { AccordionModule } from 'primeng/accordion';
import { FaqMoreInfoComponent } from './faq-more-info/faq-more-info.component';
import { DialogService, DynamicDialogRef, DynamicDialogModule } from 'primeng/dynamicdialog';
import { SignalsService } from '@shared/services/signals/signals.service';
interface FaqGroups {
  general: any[];
  flights: any[];
  analyze: any[];
  search: any[];
  admin: any[];
}

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [
    CommonModule,
    BreadcrumbComponent,
    AccordionModule,
    DynamicDialogModule
  ],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss'
})


export class FaqComponent implements OnInit, OnDestroy {

  ref: DynamicDialogRef | undefined;

  path: string = '';
  routeSub?: Subscription;
  adminSub?: Subscription;

  faqGroups?: FaqGroups;
  faqGroupedQuestions?: any[];
  isAdmin: boolean = false;

  

  constructor(
    private route: ActivatedRoute,
    private faqService: FaqService,
    public dialogService: DialogService,
    private signalService: SignalsService
  ) { }

  ngOnInit(): void {
    this.adminSub = this.signalService.isAdminRole$.subscribe( (isAdmin) => {
      this.isAdmin = isAdmin;
    });
    this.faqGroups = {
      general: this.faqService.getGeneralFAQ(),
      flights: this.faqService.getFlightsFAQ(),
      analyze: this.faqService.getAnalyzeFAQ(),
      search: this.faqService.getSearchFAQ(),
      admin: this.faqService.getAdminFAQ()
    }
    this.routeSub = this.route.params.subscribe(params => {
      this.path = params['path'];
      if (this.path === 'general') {
        this.faqGroupedQuestions = this.faqGroups?.general;
      } else if (this.path === 'flights') {
        this.faqGroupedQuestions = this.faqGroups?.flights;
      } else if (this.path === 'analyze') {
        this.faqGroupedQuestions = this.faqGroups?.analyze;
      } else if (this.path === 'search') {
        this.faqGroupedQuestions = this.faqGroups?.search
      } else if (this.path === 'admin') {
        this.faqGroupedQuestions = this.faqGroups?.admin
      }
    })
  }

  moreInfo(category: string, code: string) {
    const _category = this.faqGroups?.flights.filter(f => f.category === category);
    const questionData = _category?.map(c => {
      return c.faqs.filter((f: any) => f.code === code)[0];
    });
    this.ref = this.dialogService.open(FaqMoreInfoComponent, {
      data: {
        data: questionData
      },
      header: questionData?.[0].linkTitle,
      width: '50vw',
      modal: true,
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw'
      },
    });
  }

  ngOnDestroy(): void {
    this.routeSub?.unsubscribe();
    this.adminSub?.unsubscribe();
  }
}
